import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M6.924 6.641c0-.961.129-1.894.373-2.779a9.259 9.259 0 1 0 12.84 12.84c-.885.244-1.817.374-2.779.374-5.763 0-10.434-4.671-10.434-10.434Zm1.176 0a9.258 9.258 0 0 0 9.258 9.259c1.36 0 2.65-.293 3.811-.818a.59.59 0 0 1 .779.778A10.438 10.438 0 0 1 12.435 22C6.672 22 2 17.328 2 11.565 2 7.332 4.52 3.69 8.14 2.052a.588.588 0 0 1 .778.779A9.223 9.223 0 0 0 8.1 6.64Z"
    />
  </svg>
`;
